// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__1uz1W","title":"home_title__12FEX"};